/*
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2024-07-12 11:05:34
 * FilePath     :\abackup-pay\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import {
  Button,
  Select,
  Table,
  TableColumn,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  MessageBox,
  Message,
  Alert,
  Dialog,
  Loading,
  Row,
  Col,
  Card
} from "element-ui";

Vue.use(Button)
  .use(Select)
  .use(Input)
  .use(InputNumber);
Vue.use(Form)
  .use(FormItem)
  .use(Radio)
  .use(RadioGroup)
  .use(RadioButton);
Vue.use(Table).use(TableColumn);
Vue.use(Breadcrumb).use(BreadcrumbItem);
Vue.use(Tabs).use(TabPane);
Vue.use(Alert);
Vue.use(Dialog);
Vue.use(Row)
  .use(Col)
  .use(Card);
Vue.use(Loading);

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
